var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import Stack from '@mui/material/Stack';
import AccurityIconButton from '../../buttons/components/AccurityIconButton';
export var UserMessage = function (_a) {
    var id = _a.id, title = _a.title, message = _a.message, onDismiss = _a.onDismiss, _b = _a.collapsed, collapsed = _b === void 0 ? false : _b, otherProps = __rest(_a, ["id", "title", "message", "onDismiss", "collapsed"]);
    return (React.createElement("div", __assign({ className: classNames('userMessage', { 'userMessage--collapsed': collapsed }) }, otherProps),
        React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center" },
            React.createElement("strong", { className: "userMessage__title" }, title)),
        onDismiss && (React.createElement(AccurityIconButton, { onClick: function () { return onDismiss(id); }, iconName: "mui:Close", "aria-label": "userMessage__button", color: "light", size: "small", className: "userMessage__dismiss" })),
        React.createElement("p", { className: "userMessage__message" }, message)));
};
export default UserMessage;
//# sourceMappingURL=UserMessage.js.map